import { render } from "./DanmarksKort.vue?vue&type=template&id=1e60f1fa"
import script from "./DanmarksKort.vue?vue&type=script&lang=js"
export * from "./DanmarksKort.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__